class CheckoutController {

    constructor($scope, checkout, basket) {
        this.$scope = $scope;
        this.checkout = checkout;
        this.basket = basket;
    }

    $onInit () {
        this.watchCheckoutError();
        this.watchBasketPaymentError();
        this.watchBasketContentsOption();
        this.watchBasketSubmitSuccess();
    }

    watchCheckoutError () {
        this.$scope.$watch(() => this.checkout.error, (newVal, oldVal) => {
            if (!newVal) {
                this.checkoutError = [];
                this.combineErrors();
            }
            if (newVal !== oldVal) {
                this.checkoutError = newVal;
                this.combineErrors();
                this.checkout.scrollToError();
            }
        }, true);
    }

    watchBasketPaymentError () {
        this.$scope.$watch(() => this.basket.paymentErrors, (newVal, oldVal) => {
            this.basketPaymentError = {};
            if (!newVal) {
                this.showPaymentError = false;
                this.basketPaymentError = {};
            }
            if (newVal !== oldVal && newVal) {
                newVal.forEach((error) => this.basketPaymentError[error] = true);
                this.showPaymentError = true;
                this.checkout.scrollToError();
            }
        }, true);
    }

    watchBasketContentsOption () {
        this.$scope.$watch(() => this.basket.contents.option, (newVal, oldVal) => {
            if (newVal && newVal !== oldVal) {
                switch (newVal) {
                    case 'delete_orders':
                        this.checkout.invalidateOrder();
                        break;
                }
            }
        }, true);
    }

    watchBasketSubmitSuccess () {
        this.$scope.$watch(() => this.basket.success, (newVal, oldVal) => {
            if (newVal && newVal === true) {
                this.checkout.setSteps();
            }
        });
    }

    combineErrors () {
        if (this.checkoutError && this.checkoutError.length > 0) {
            this.totalErrors = this.checkoutError.filter(error => !!error);
            return;
        }
        this.totalErrors = undefined;
    }
}

CheckoutController.$inject = ['$scope', 'checkout', 'basket'];

export default CheckoutController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/controllers/checkout.controller.js